import React, { useState } from 'react';
import { 
  Building2, 
  Target, 
  Users, 
  Calendar, 
  CheckCircle2, 
  Clock, 
  HardHat, 
  HeartHandshake,
  TrendingUp,
  Plus
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { ChurchBranding } from './ChurchBranding';
// 1. Import your Modal component
import ProjectModal from './ProjectModal'; 

export const DevelopmentDashboard = () => {
  const { user } = useAuth();
  
  // 2. State to control the modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  // State for a sample project progress
  const [projectGoal, setProjectGoal] = useState(5000000);
  const [raisedAmount, setRaisedAmount] = useState(2750000);

  const progressPercentage = Math.round((raisedAmount / projectGoal) * 100);

  return (
    <div className="space-y-6 animate-in fade-in duration-500 relative">
      <ChurchBranding departmentName="Development & Projects" />
      
      {/* Header Section */}
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-black text-gray-900 flex items-center gap-3">
          <Building2 className="w-8 h-8 text-indigo-600" /> Projects & Development
        </h2>
        
        {/* 3. Updated Button to trigger the modal */}
        <button 
          onClick={() => setIsModalOpen(true)}
          className="px-4 py-2 bg-indigo-600 text-white rounded-xl text-xs font-bold shadow-md shadow-indigo-100 flex items-center gap-2 hover:bg-indigo-700 transition-all cursor-pointer"
        >
          <Plus className="w-4 h-4" /> New Project
        </button>
      </div>

      {/* active Project Highlight (e.g., New Sanctuary) */}
      <div className="bg-white p-8 rounded-3xl border border-gray-100 shadow-sm">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
          <div className="space-y-2">
            <span className="px-3 py-1 bg-indigo-50 text-indigo-600 rounded-full text-[10px] font-black uppercase tracking-wider">
              Primary Project
            </span>
            <h3 className="text-2xl font-black text-gray-900">Main Sanctuary Expansion</h3>
            <p className="text-sm text-gray-500 max-w-md">Construction phase: Roofing & Internal Finishes. Estimated completion: Dec 2024.</p>
          </div>
          <div className="text-right">
            <p className="text-xs font-bold text-gray-400 uppercase">Fundraising Progress</p>
            <h4 className="text-3xl font-black text-indigo-600">{progressPercentage}%</h4>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="mt-6 w-full h-4 bg-gray-100 rounded-full overflow-hidden">
          <div 
            className="h-full bg-indigo-600 rounded-full transition-all duration-1000"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
        <div className="mt-3 flex justify-between text-xs font-bold text-gray-400">
          <span>Raised: KES {raisedAmount.toLocaleString()}</span>
          <span>Goal: KES {projectGoal.toLocaleString()}</span>
        </div>
      </div>

      {/* ... rest of your dashboard UI (Milestones, Team, etc.) ... */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100 lg:col-span-2">
          <h3 className="font-bold text-gray-900 mb-6 flex items-center gap-2">
            <CheckCircle2 className="w-5 h-5 text-emerald-500" /> Key Milestones
          </h3>
          {/* Milestone Content */}
        </div>
        
        <div className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100">
           <h3 className="font-bold text-gray-900 mb-6 flex items-center gap-2">
            <Users className="w-5 h-5 text-indigo-500" /> Project Team
          </h3>
          {/* Team Content */}
        </div>
      </div>

      {/* 4. INSERT THE MODAL COMPONENT HERE */}
      <ProjectModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        shopId={user?.shop_id ?? undefined}  
      />

      {/* Fundraiser Analytics Placeholder */}
      <div className="bg-indigo-900 p-6 rounded-3xl text-white overflow-hidden relative">
        <div className="relative z-10">
          <h4 className="font-bold flex items-center gap-2 mb-2">
            <TrendingUp className="w-4 h-4" /> Fundraiser Insights
          </h4>
          <p className="text-xs text-indigo-200 mb-4">Average donation size per project member has increased by 15% this month.</p>
        </div>
        <TrendingUp className="absolute -right-4 -bottom-4 w-32 h-32 text-white/5" />
      </div>
    </div>
  );
};
